<template>
    <div>
        <div class="mt-3">
            <autoCompleteComponent :getValue="getTimeZone" placeholder="Search For Address"></autoCompleteComponent>
        </div>
        <div class="selectLayout mt-3">
            <div class="mt-6 mb-3">
                <label class="block text-xs font-bold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Single
                </label>
            </div>
            <div class="row">
                <div class="col-6 mb-3">
                    <div :class="`cardWrapper ${layout === 'sv1' ? 'active' :''}`" @click="onLayoutChange('sv1')">
                        <div
                            class="bg-light text-center border-transparent p-3  mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <i class="fas fa-square"></i>
                        </div>
                        <div class="text-center mt-1 text-xs">
                            version 1
                        </div>
                    </div>
                </div>
                <div class="col-6 mb-3">
                    <div :class="`cardWrapper ${layout === 'sv2' ? 'active' :''}`" @click="onLayoutChange('sv2')">
                        <div
                            class="bg-light text-center border-transparent p-3 mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <i class="fas fa-box"></i>
                        </div>
                        <div class="text-center mt-1 text-xs">
                            version 2
                        </div>
                    </div>
                </div>
                <div class="col-6 mb-3">
                    <div :class="`cardWrapper ${layout === 'sv3' ? 'active' :''}`" @click="onLayoutChange('sv3')">
                        <div
                            class="bg-light text-center border-transparent p-3 mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <i class="fas fa-box"></i>
                        </div>
                        <div class="text-center mt-1 text-xs">
                            version 3
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-6 mb-3">
                <label class="block text-xs font-bold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Forecast
                </label>
            </div>
            <div class="row">
                <div class="col-6 mb-3">
                    <div :class="`cardWrapper ${layout === 'fv1' ? 'active' :''}`" @click="onLayoutChange('fv1')">
                        <div
                            class="bg-light text-center border-transparent p-3 mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <i class="fas fa-boxes"></i>
                        </div>
                        <div class="text-center mt-1 text-xs">
                            version 1
                        </div>
                    </div>
                </div>
                <div class="col-6 mb-3">
                    <div :class="`cardWrapper ${layout === 'fv2' ? 'active' :''}`" @click="onLayoutChange('fv2')">
                        <div
                            class="bg-light text-center border-transparent p-3 mb-2 rounded position-relative d-flex align-items-center justify-content-center h-16">
                            <i class="fa-th-list fas"></i>
                        </div>
                        <div class="text-center mt-1 text-xs">
                            version 2
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Layout
            </label>
            <select @change="onLayoutChange($event)" name="layout" type="text" class="form-control " :value="layout">

                <option value="full">Forecast</option>
                <option value="single">Single</option>

            </select>
        </div> -->
        <div class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Language
            </label>
            <select name="lang" @change="changelang($event)" :value="lang" class="form-control">
                <option value="de">Deutsch</option>
                <option value="en">English</option>
                <option value="tr">Turkish</option>
                <option value="ar">Arabic</option>
            </select>
        </div>
        <div class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Font Family
            </label>
            <select name="fontFamily" @change="changeFontFamily($event)" :value="fontfamily" class="form-control">
                <option  v-for="(item,index) in fontsList" v-bind:key="item.value + '_' + index" :style="{fontFamily:item.value}" :value="item.value">{{item.name}}</option>
            </select>
        </div>
        <div class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                UNITS
            </label>
            <select @change="onChange($event)" name="format" type="text" class="form-control " :value="unit">

                <option value="C">Celsius</option>
                <option value="F">Fahrenheit</option>

            </select>
        </div>

        <!-- <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label
                    class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    SHOW FORECAST
                </label>
                <Switches theme="bootstrap" v-model="showForcast" color="success"></Switches>
            </div>
        </div> -->
        <!-- <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label
                    class="d-block flex-grow-1 text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Transparent background
                </label>
                <Switches theme="bootstrap" v-model="transparentbg" color="success"></Switches>
            </div>
        </div> -->
        <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Text Color
                    </label>

                    <input type="color" @input="onColorChange($event)" name="backgroundColor" class="custonInput"
                        :value="color" />
                </div>
            </div>
        </div>
        <!-- <div class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Background Color
                    </label>

                    <input type="color" @input="onbgColorChange($event)" name="backgroundColor" class="custonInput"
                        :value="bgColor" />
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
// import Switches from 'vue-switches';
import autoCompleteComponent from "../../../utils/AutoComplete.vue";
import { Fontfamilies } from "../../../commonJSON";

export default {
    name: "WeatherAppSettings",
    components: {
        // Switches,
        autoCompleteComponent
    },
    data() {
        return {
            showForcast: false,
            color: "",
            bgColor: "",
            unit: "",
            layout: "",
            transparentbg: false,
            fontsList:Fontfamilies,
            fontfamily:'arial',
            lang:"de"
        }
    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
    watch: {
        "$store.state.activeObjectprops": {
            handler(updatedValues) {

                this.showForcast = updatedValues?.showForcast;
                this.color = updatedValues?.color;
                this.bgColor = updatedValues?.bgColor;
                this.unit = updatedValues?.unit;
                this.layout = updatedValues?.layout;
                this.transparentbg = updatedValues?.transparentbg;
                this.fontfamily = updatedValues?.fontfamily;
                this.lang = updatedValues?.lang;
            },
            deep: true,
            immediate: true

        },

        showForcast(value) {
            this.showForcastOnWeather(value)
        },
        transparentbg(value) {
            this.onTransparentBG(value)
        }
    },
    methods: {
        onChange(e) {
            this.$store.dispatch("setCurrentObjectProperties", { unit: e.target.value });
        },
        getTimeZone(value) {
            debugger // eslint-disable-line no-debugger
            console.log(value)
            this.$store.dispatch("setCurrentObjectProperties", { city: value ? value : "" });

        },
        showForcastOnWeather(value) {
            this.$store.dispatch("setCurrentObjectProperties", { showForcast: value });
        },
        onTransparentBG(value) {
            this.$store.dispatch("setCurrentObjectProperties", { transparentbg: value });
        },
        onColorChange(e) {
            let value = e.target.value;

            this.$store.dispatch("setCurrentObjectProperties", { color: value });
        },
        onbgColorChange(e) {
            let value = e.target.value;

            this.$store.dispatch("setCurrentObjectProperties", { bgColor: value });
        },

        onLayoutChange(e) {
            if(e === "sv1" || e === "sv2" || e === "sv3" ){
                this.$store.dispatch("setCurrentObjectProperties", { width: e === "sv2" || e === "sv3" ?  650 :   1000 , fs: e === "sv2" || e === "sv3" ? 120  : 130  });
            }
            if(e === "fv1" || e === "fv2"){
                this.$store.dispatch("setCurrentObjectProperties", { width: e === "fv1" ? 860 : 1100, isAuto : false , fs: e === "fv1" ? 40 : 55 });

            }
            this.$store.dispatch("setCurrentObjectProperties", { layout: e   });
           
        },
        changeFontFamily(e){
            let value = e.target.value;
           
            this.$store.dispatch("setCurrentObjectProperties" , { fontfamily:  value });
        },
        changelang(e){
            let value = e.target.value;
           
            this.$store.dispatch("setCurrentObjectProperties" , { lang:  value });
        },

    }
}
</script>
<style scoped>
.cardWrapper{
    cursor: pointer;
}
.cardWrapper.active .border-transparent {
    border-color: #8e42ff !important;
    border-style: solid;
}
</style>